import { __read, __spread } from "tslib";
import { formatValue as valueFormatter, } from '@keen.io/charts-utils';
import { KEEN_KEY } from '@keen.io/parser';
import { VALUE } from '../../constants';
export var categoricalTransformation = function (data, keys, formatValue, dataSeriesGroups) {
    var columns = __spread(dataSeriesGroups, [VALUE]);
    var rows = [];
    var isMultiGroup = dataSeriesGroups.length > 1;
    data.forEach(function (item) {
        rows.push.apply(rows, __spread(keys.map(function (keyName) { return __spread((isMultiGroup ? [item[KEEN_KEY], keyName] : [keyName]), [
            valueFormatter(item[keyName], formatValue),
        ]); })));
    });
    return __spread([columns], rows);
};
